export enum DateFormat {
  Year = 'YYYY',
  MonthYear = 'MM/YYYY',
  MonthDayYear = 'MM/DD/YYYY',
}
